import service from '../service';
import store from '../../store';


export function getTechServiceFeeList(params) {
	return service.post('/ams/consignorMoney/querySapInfoServiceFreeList', params);
}

export function findSapState(params) {
  return service.post('/ams/sap/apply/findSapState.xhtml', {
    ...params,
    load: false
  });
}
export function findJddState(params) {
    return service.post('/ams/sap/apply/findJddState.xhtml', {
      ...params,
      load: false
    });
  }

export function consignorMoneyListExport(params) {
	return service.post('/ams/consignorMoney/consignorMoneyListExport', params);
}

export function queryHaveOpen(params, otherConfig) {
	return service.post('/ams/sap/apply/queryHaveOpen', params, otherConfig);
}
//货主前台-借款申请
export function creditLoanOrderList(params) {
	return service.post('/ams/creditLoanOrder/queryList', params );
}
//借款申请导出
export function Export(params) {
	return service.post('/ams/creditLoanOrder/export', params);
}

